import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { SignIn } from "@phosphor-icons/react";

export default function LoginPage() {
  const { login, status } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (status === "authed") return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(username.trim(), password);
    } catch {
      // Silent — no user-facing feedback on failure (per product requirement).
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f5f4] px-4">
      <div
        className="w-full max-w-sm bg-white border border-[#18181b] hard-shadow"
        data-testid="login-card"
      >
        <form onSubmit={handleSubmit} className="px-6 py-6 space-y-4">
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
            required
            autoComplete="username"
            data-testid="login-username"
            className="w-full font-mono text-sm border border-[#d4d4d8] px-3 py-2.5 bg-white focus:outline-none focus:border-[#0047FF] focus:ring-1 focus:ring-[#0047FF]"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            data-testid="login-password"
            className="w-full font-mono text-sm border border-[#d4d4d8] px-3 py-2.5 bg-white focus:outline-none focus:border-[#0047FF] focus:ring-1 focus:ring-[#0047FF]"
          />

          <button
            type="submit"
            disabled={submitting || !username || !password}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-[#0047FF] text-white px-4 py-2.5 text-sm hover:bg-[#0036CC] transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <SignIn size={14} weight="bold" />
            {submitting ? "Вход..." : "Войти"}
          </button>
        </form>
      </div>
    </div>
  );
}
